<template>
  <div>
    <!-- 搜索/新增 -->
    <div class="list-hd">
      <el-form :inline="true" v-model="searchValue" class="demo-form-inline">
        <el-form-item label="游戏:">
          <el-select
            v-model="searchValue.game_id"
            filterable
            clearable
            placeholder="请选择"
            @change="selectChannel"
            @clear="gameClear"
          >
            <el-option
              v-for="item in gamesList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道:">
          <el-select
            v-model="searchValue.channel_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in channelSelectList"
              :key="i"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="区服:">
          <el-select
            v-model="searchValue.zone_id"
            filterable
            clearable
            multiple
            collapse-tags
            placeholder="请选择"
          >
            <el-option
              v-for="(item, i) in serverSelectList"
              :key="i"
              :label="item.name"
              :value="item.zone_id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="日期:">
          <el-date-picker
            v-model="value1"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="渠道包组:">
          <el-select
            v-model="searchValue.group_channel_ids"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in channelGroupSelectList"
              :key="item.id"
              :label="item.group_name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="新增类型:">
          <el-select
            v-model="searchValue.append_type"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in appendType"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否分渠道">
          <el-select
            v-model="searchValue.is_channel"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in listRechannel"
              :value="item.id"
              :label="item.name"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchFirstPayStatisticsDayList"
            >搜索</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="success" @click="exportFirstPayStatisticsDay()"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <el-table
      stripe
      ref="table"
      v-loading="loadingData"
      :data="tableData"
      :max-height="tableHeight"
      border
      style="width: 100%"
    >
      <el-table-column prop="login_date" label="日期"> </el-table-column>
      <el-table-column prop="game.game_name" label="游戏"></el-table-column>
      <el-table-column prop="channels.channel_name" label="渠道名">
      </el-table-column>

      <el-table-column
        v-if="searchValue.zone_id.length != 0"
        prop="zone.name"
        label="区服"
      ></el-table-column>
      <el-table-column prop="new_users" label="当日新增"> </el-table-column>
      <el-table-column prop="today" label="本日新增付费数"> </el-table-column>
      <el-table-column prop="pay_users" label="累计新增付费数">
      </el-table-column>
      <el-table-column prop="this_day" label="首日付费转化率">
      </el-table-column>
      <el-table-column prop="two_day" label="2日付费转化率"> </el-table-column>
      <el-table-column prop="three_day" label="3日付费转化率">
      </el-table-column>
      <el-table-column prop="week" label="4-7日付费转化率"> </el-table-column>
      <el-table-column prop="month" label="8-30付费转化率"> </el-table-column>
      <el-table-column prop="total_rate" label="总付费率"> </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[15, 30, 45, 60]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalRecords"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import fetch from "@/assets/js/axios.js";
import { urlSplicing } from "@/assets/js/public.js";
import moment from "moment";
export default {
  name: "firstPayStatistics",
  components: {},
  data() {
    return {
      loadingData: false,
      searchValue: {
        game_id: "",
        channel_id: [],
        zone_id: [],
        created_from: "",
        created_to: "",
        group_channel_ids: "",
        is_channel: "",
        append_type: "",
      },
      listRechannel: [
        {
          id: 0,
          name: "不分渠道",
        },
        {
          id: 1,
          name: "分渠道",
        },
      ],
      appendType: [
        {
          id: "reg_num ",
          name: "新增账号",
        },
        {
          id: "total_num ",
          name: "总新增角色",
        },
        {
          id: "first_num ",
          name: "首次新增角色",
        },
        {
          id: "repeat_num ",
          name: "新增滚服角色",
        },
      ],
      value1: [],
      tableHeight: 0,
      historyValue: {},
      tableData: [],
      gamesList: [],
      loginDetailData: [],
      channelSelectList: [],
      channelSelectAllList: [],
      serverSelectList: [],
      channelGroupSelectList: [],
      totalRecords: 0,
      currentPage: 1,
      pageSize: 15,
    };
  },
  computed: {
    ...mapState(["host"]),
  },
  created() {
    this.value1[0] = moment().startOf("month").format("YYYY-MM-DD");
    this.value1[1] = moment().endOf("month").format("YYYY-MM-DD");

    this.searchValue.created_from = this.value1[0];
    this.searchValue.created_to = this.value1[1];
    this.getchannelSelectList();
    this.channelGroupSelect();
    this.getGameSelectList();
    this.getFirstPayStatisticsList(true);
  },
  updated() {
    this.$nextTick(() => {
      this.$refs["table"].doLayout();
    });
  },
  beforeMount(height) {
    var h = document.documentElement.clientHeight;
    this.tableHeight = h - 60; //减去页面上固定高度height
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.getFirstPayStatisticsList(false);
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getFirstPayStatisticsList(false);
    },

    //首次付费转化率列表 导出
    exportFirstPayStatisticsDay() {
      let params = {
        ...this.historyValue, // 传对应的搜索的值
        export: 1,
        token: sessionStorage.getItem("access_token"),
      };

      urlSplicing(this.host + "admin/cycle_statistics/first_pay_rate", params);
    },
    // 获取游戏选择列表数据
    getGameSelectList() {
      fetch({
        url: "/admin/games/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.gamesList = res.data.data;
        }
      });
    },

    // 获取渠道选择列表数据
    getchannelSelectList() {
      fetch({
        url: "/admin/channels/select",
        method: "GET",
      }).then((res) => {
        if (res.data.status) {
          this.channelSelectAllList = res.data.data;
          this.channelSelectList = res.data.data;
        }
      });
    },
    // 渠道包组 下拉选择列表
    channelGroupSelect() {
      fetch({
        url: "/admin/channel_package_group/select",
        method: "GET",
      }).then((res) => {
        this.channelGroupSelectList = res.data.data;
      });
    },

    // 获取区服选择列表数据
    getServerSelectList(vid) {
      fetch({
        url: "/admin/zones/select",
        method: "GET",
        params: {
          game_id: vid,
        },
      }).then((res) => {
        if (res.data.status) {
          this.serverSelectList = res.data.data;
        }
      });
    },

    // 根据所属游戏,显示对应的所属渠道/区服
    selectChannel(vid) {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.channelSelectList = [];
      this.channelSelectAllList.forEach((item, i) => {
        if (item.game_id == vid) {
          this.channelSelectList.push(item);
        }
      });
      if (vid) {
        this.getServerSelectList(vid);
      }
    },
    // 清空游戏选项
    gameClear() {
      this.searchValue.zone_id = [];
      this.searchValue.channel_id = [];
      this.serverSelectList = [];

      this.getchannelSelectList();
    },
    // 实现首次付费转化率列表的搜索
    searchFirstPayStatisticsDayList() {
      this.searchValue.created_from = this.value1 && this.value1.length === 2 ? this.value1[0] : '';
      this.searchValue.created_to = this.value1 && this.value1.length === 2 ? this.value1[1] : '';
      this.currentPage = 1;
      this.getFirstPayStatisticsList(true);
    },

    //获取 首次付费转化率 列表
    getFirstPayStatisticsList(reload = false) {
      let searchValue = {};
      if (reload) {
        this.historyValue = JSON.parse(JSON.stringify(this.searchValue));
        searchValue = this.searchValue;
      } else {
        searchValue = this.historyValue;
      }
      this.loadingData = true;
      let channel_id = this.searchValue.channel_id.toString();
      let zone_id = this.searchValue.zone_id.toString();
      fetch({
        url: "admin/cycle_statistics/first_pay_rate",
        method: "GET",
        params: {
          ...searchValue,
          channel_id: channel_id,
          zone_id: zone_id,
          page: this.currentPage,
          per_page: this.pageSize,
        },
      })
        .then((res) => {
          if (res.data.status) {
            this.tableData = res.data.data.data;
            this.totalRecords = res.data.data.total;
          }
        })
        .finally(() => {
          this.loadingData = false;
        });
    },
  },
};
</script>
<style lang="less">
.pagination {
  text-align: right;
  margin-top: 20px;
  padding-bottom: 20px;
}
.list-hd {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 20px;
  .el-input-group {
    width: 370px;
  }
}
.scope {
  display: flex;
  span {
    display: inline-block;
    padding: 0 10px;
  }
  .el-input {
    width: 100px;
  }
}
</style>
